import { render, staticRenderFns } from "./PreviewGradingCriteria.vue?vue&type=template&id=7971a886&scoped=true"
import script from "./PreviewGradingCriteria.vue?vue&type=script&lang=js"
export * from "./PreviewGradingCriteria.vue?vue&type=script&lang=js"
import style0 from "./PreviewGradingCriteria.vue?vue&type=style&index=0&id=7971a886&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7971a886",
  null
  
)

export default component.exports